import AUMTable from "./AssetAumTable"
import FirmAUMTable from "./FirmAUM"

export { AUMTable, FirmAUMTable }

export default AUMTable
